<template>
  <div
    :class="{'spl-message-modal-holder-show': isVisible}"
    class="spl-message-modal-holder"
    @click.self="closeMessageModal">
    <div
      :class="{'spl-message-modal__error': messageType === 'Error',
               'spl-message-modal__success': messageType === 'Success',
               'spl-message-modal__warning': messageType === 'Warning',
               'spl-message-modal__info': messageType === 'Info' }"
      class="spl-message-modal">
      <!-- Error Header -->
      <div v-if="messageType === 'Error'" class="spl-message-modal__label">
        <img src="../../assets/icon-alerted.svg"> We are sorry {{ firstName }}, but something went wrong...
      </div>
      <!-- Success Header -->
      <div v-if="messageType === 'Success'" class="spl-message-modal__label">
        <img src="../../assets/icon-check.svg"> Wow {{ firstName }} great success...
      </div>
      <!-- Warning Header -->
      <div v-if="messageType === 'Warning'" class="spl-message-modal__label">
        <img src="../../assets/icon-alerted.svg"> Hey {{ firstName }} have a closer look...
      </div>
      <!-- Info Header -->
      <div v-if="messageType === 'Info'" class="spl-message-modal__label">
        <img src="../../assets/icon-award.svg"> Hey {{ firstName }} check this out ...
      </div>

      <div class="spl-message-modal__close" @click="closeMessageModal" />

      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="spl-message-modal__content" v-html="message" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MessageModal',
  data () {
    return {
      isVisible: false,
      messageType: '',
      message: ''
    }
  },
  computed: {
    ...mapGetters('user', ['firstName'])
  },
  mounted () {
    // Error Modal
    window.bus.$on('openErrorModal', this.handleOpenErrorModal)
    // Success Modal
    window.bus.$on('openSuccessModal', this.handleOpenSuccessModal)
    // Warning Modal
    window.bus.$on('openWarningModal', this.handleOpenWarningModal)
    // Info Modal
    window.bus.$on('openInfoModal', this.handleOpenInfoModal)
  },
  beforeDestroy () {
    // Error Modal
    window.bus.$off('openErrorModal', this.handleOpenErrorModal)
    // Success Modal
    window.bus.$off('openSuccessModal', this.handleOpenSuccessModal)
    // Warning Modal
    window.bus.$off('openWarningModal', this.handleOpenWarningModal)
    // Info Modal
    window.bus.$off('openInfoModal', this.handleOpenInfoModal)
  },
  methods: {
    handleOpenErrorModal (message) {
      this.isVisible = true
      this.messageType = 'Error'
      this.message = message
    },
    handleOpenSuccessModal (message) {
      this.isVisible = true
      this.messageType = 'Success'
      this.message = message
    },
    handleOpenWarningModal (message) {
      this.isVisible = true
      this.messageType = 'Warning'
      this.message = message
    },
    handleOpenInfoModal (message) {
      this.isVisible = true
      this.messageType = 'Info'
      this.message = message
    },
    closeMessageModal () {
      this.isVisible = false
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';
    .spl-message-modal-holder {
        background-color: rgba(0, 0, 0, 0.5);
        display: none;
        height: 100vh;
        left: 0;
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 90000;
          overflow: auto;

        &-show {
            display: block;
        }
        .spl-message-modal {

            left: 50%;
            padding: 20px 15px 30px 15px;
            position: absolute !important;
            top: 25%;
            transform: translate3d(-50%, 0, 0);
            width: 700px;

            @include mobile() {
                left: $mobilePadding;
                transform: translate3d(0, 0, 0);
                top: $mobilePadding;
                width: calc(100% - #{$mobilePadding*2});
            }
            &__error{
              background-color: $redBackground;
            }
            &__success{
              background-color: $grayBackground;
            }
            &__warning{
              background-color: $lightYellow;
            }
            &__info{
              background-color: $lightYellow;
            }
            &__label {
                font-size: 18px;
                font-weight: 600;
                margin-bottom: 20px;
            }
            &__close {
                background-image: url(../../assets/icon-close.svg);
                background-position: center center;
                background-repeat: no-repeat;
                cursor: pointer;
                height: 25px;
                position: absolute;
                right: 10px;
                top: 20px;
                transition: opacity $shortTransition ease-in-out;
                width: 25px;

                &:hover {
                    opacity: 0.5;
                }
            }

            &__content {
              padding-bottom: 10px;
            }
            .spl-message-label {
                color: $parcelDetailBlockLabelColor;
            }
            .spl-message-button {
                margin-bottom: 0;
            }
        }
    }

</style>
